// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/trim-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/trim-technique/antiservo-tab.js';
import g1 from '../lessons/aeronautics/trim-technique/trim-technique.js';

mount([g0, g1]);
